import { render, staticRenderFns } from "./Schedules-Admin.vue?vue&type=template&id=5f83f1fe&scoped=true"
import script from "./Schedules-Admin.js?vue&type=script&lang=js&external"
export * from "./Schedules-Admin.js?vue&type=script&lang=js&external"
import style0 from "./Schedules-Admin.vue?vue&type=style&index=0&id=5f83f1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83f1fe",
  null
  
)

export default component.exports